<template>
  <div style="margin: 0px; padding: 0px;">
    <el-container direction="vertical" class="layout-container">
      <HEAD :active="active"></HEAD>
      <el-main class="el-main-ms">
        <!--图片层-->
        <div class="block div-mg-all">
          <div class="ms-yd-div ">
            <el-row style="margin: 5px;">
              <el-col :span="8"><el-image :src="ydImgSrc" style="vertical-align: middle;"></el-image>客房预订</el-col>
              <el-col :span="8"><el-image :src="ydImgSrc1" style="vertical-align: middle;"></el-image>陌叽严选</el-col>
              <el-col :span="8"><el-image :src="ydImgSrc2" style="vertical-align: middle;"></el-image>集采优品</el-col>
            </el-row>
            <el-row style="margin: 5px;">
              <el-col :span="8"><el-button @click="roomReservation('https://wx9eb264cd8c475cfd.wx.gcihotel.net/wechat/?/=#/book')" type="primary" size="small" class="ms-yd-ft">点击进入</el-button></el-col>
              <el-col :span="8"><el-button @click="moJiYanXuan('https://wx9eb264cd8c475cfd.wx.gcihotel.net/wechatMall/?/#/index')" type="primary" size="small" class="ms-yd-ft">点击进入</el-button></el-col>
              <el-col :span="8"><el-button @click="centralized('https://4019802568438.retail.n.weimob.com/saas/retail/4019802568438/0/shop/index?id=13384880')" type="primary" size="small" class="ms-yd-ft">点击进入</el-button></el-col>
            </el-row>
          </div>
          <el-image :src="imgSrc" fit="fill" style="width: 100%; height: 500px;"></el-image>
        </div>
        <!--联系我们-->
        <contact-plugin></contact-plugin>
      </el-main>
      <FOOT></FOOT>
    </el-container>
  </div>
</template>

<script>
import HEAD from './Head'
import FOOT from './Foot'
import ContactPlugin from "@/components/ContactPlugin";
export default {
  name: "MsTrader",
  metaInfo: {
    title: '陌上酒店集团官网', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '陌上商旅'
    },{
      name: 'description',
      content: '客房预订、陌叽严选、集采优品'
    }]
  },
  data() {
    return {
      active: '4',
      imgSrc: require('../assets/images/1440-560.png'),
      ydImgSrc: require('../assets/images/yuding/yd-kf.png'),
      ydImgSrc1: require('../assets/images/yuding/yd-yx.png'),
      ydImgSrc2: require('../assets/images/yuding/yd-jc.png'),
    }
  },
  components: {
    HEAD,
    FOOT,
    ContactPlugin
  },
  methods:{
    roomReservation(url){
         window.open(url,"_blank");
         //_blank : 在新窗口打开
         //_self : 在当前窗口打开
         //window.location.href = url : 当前页面重定向
       },
    moJiYanXuan(url){
      window.open(url,"_blank");
      //_blank : 在新窗口打开
      //_self : 在当前窗口打开
      //window.location.href = url : 当前页面重定向
    },
    centralized(url){
      window.open(url,"_blank");
      //_blank : 在新窗口打开
      //_self : 在当前窗口打开
      //window.location.href = url : 当前页面重定向
    }
   }
}
</script>

<style scoped>
  .ms-yd-div {
    height: 80px;
    width: 600px;
    background-color: red;
    position: absolute;
    top: 380px;
    z-index: 999;
    background-color: #fff;
    opacity: 0.8;
    left: 50%;
    margin-left: -300px;
    color: #1B8481;
    border-radius: 5px;
  }
  .ms-yd-ft {
    background-color: #1B8481;
  }
  .ms-yd-ft:hover {
    color: white;
    background-color: #1B8481;
    opacity: 0.8;
  }
</style>

